import { render, staticRenderFns } from "./lrDataPanel.vue?vue&type=template&id=65e72ec8&"
import script from "./lrDataPanel.vue?vue&type=script&lang=js&"
export * from "./lrDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./lrDataPanel.vue?vue&type=style&index=0&id=65e72ec8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports